export const DESCRIPTION = [
  {
    value:
      'Циан инвестирует в собственную инфраструктуру и команду по информационной безопасности. Мы выстраиваем архитектуру с разграничением доступа и делаем акцент на сохранности персональных данных пользователей',
  },
];
